export default "__VITE_ASSET__BX8Q6GeO__"